/* eslint-disable react/prop-types */

import React from 'react';
import UserProfile from '@/screens/setting/users/components/UserProfile';

const UserDetailScreen = (props) => {
  return <UserProfile {...props} />;
};

export default UserDetailScreen;
